/* eslint-disable max-len */
import React, { FC } from "react";

import { Box } from "@mui/system";
import GoogleMapReact from "google-map-react";
// import MapBubble from "../MapBubble/MapBubble";
import MapMarker from "../MapMarker/MapMarker";
import { mapStyle } from "./MapMini.style";
import { ILocationItemResponse } from "../../services/edit-hospital-location/edit-hospital-location.interface";

interface IMapMiniProps {
  lat: number
  lng: number
  zoom?: number
  height?: string
  width?: string
  position?: any
  markers?: any[]
  mapData?: any
  onClick?: (mark : any) => void
  isBubble?: boolean
  location?: any
  setIsBubble?: (isBubble: boolean) => void
  handleUpdateLocationDetail?: (selectedLocation: ILocationItemResponse) => void
  handleOpenLocationModal?: () => void;
  isSignup?: boolean;
}

const MapMini: FC<IMapMiniProps> = ({
  lat,
  lng,
  zoom,
  height = "7.31rem",
  width = "100%",
  position,
  markers,
  mapData,
  onClick,
  isBubble,
  location,
  setIsBubble,
  handleUpdateLocationDetail,
  handleOpenLocationModal,
  isSignup,
}) => {
  const gMapsApiKey = process.env.REACT_APP_GMAPS_API_KEY;

  if (!gMapsApiKey) {
    return null;
  }

  return <Box sx={mapStyle}>
    <div style={{ height: height, width: width, position: position }}>

      <GoogleMapReact
        bootstrapURLKeys={{ key: gMapsApiKey }}
        defaultZoom={11}
        zoom={zoom}
        center={{ lat, lng } || mapData}
        options={{
          styles: require("./mapStyle.json"),
        }}
      >
        {markers?.length ? markers.map((mark, i) => (
          <MapMarker
            key={i}
            lat={mark.position.lat}
            lng={mark.position.lng}
            main={mark.position.lat === mapData.lat && mark.position.lng === mapData.lng}
            onClick={() => onClick && onClick(mark)}
            isSignup={isSignup}
            isBubble={isBubble}
            location={location}
            setIsBubble={setIsBubble}
            handleUpdateLocationDetail={handleUpdateLocationDetail}
            handleOpenLocationModal={handleOpenLocationModal}
          />
        )) : (
          <MapMarker
            lat={lat}
            lng={lng}
            // isBubble={isBubble}
            // location={location}
            // setIsBubble={setIsBubble}
            // handleUpdateLocationDetail={handleUpdateLocationDetail}
            main
          />
        )}

      </GoogleMapReact>
    </div>
  </Box>;
};

export default MapMini;
